<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c2Ebi9/tc-custom/9780802193285.jpg?1726519109878" alt="This image is the cover for the book Dying Hours, The Tom Thorne Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dying Hours, The Tom Thorne Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>“The next superstar detective” is back to stop a serial killer with a bizarre pattern—his victims are all taking their own lives (Lee Child).</b><br/>  <br/> Recently demoted for stepping out of line once too often, prickly inspector Tom Thorne is convinced that a spate of suicides among the elderly in south London is something more sinister. When his concerns are dismissed by former colleagues at the CID, and even by his patient girlfriend, Thorne can only trust himself and his best friend—gay pub-crawling pathologist Phil Hendricks—with his suspicions of murder.<br/>  <br/> Thorne draws a chilling connection between the deaths and a controversial case three decades old. But by going solo with his investigation, he not only risks the lives of those closest to him, but also further endangers those being targeted by a deranged killer—a man with the power and cold-blooded motives to coerce his vulnerable victims toward a breathtaking end.<br/>  <br/> “Tom Thorne, the hero of a well-groomed series of police procedurals” by multiple award-winning Mark Billingham, returns—and he’s “on the hunt for a killer who proves to be extremely clever and really, really mean” (<i>The New York Times Book Review</i>).<br/>  <br/> “One of the most consistently entertaining, insightful crime writers working today.” —Gillian Flynn, author of <i>Gone Girl</i><br/>  <br/> “Fiendishly clever . . . with the last sharp twist saved for the final page.” —<i>Tampa Bay Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Billingham
      </h2>
      
      <p class="authorDescription body article">Mark Billingham has twice won the Theakston&rsquo;s Old Peculier Crime Novel of the Year Award and also won the Sherlock Award for Best Detective Created by a British Author. His books, which include the critically acclaimed Tom Thorne Novels, have been translated into twenty-five languages and have sold over four million copies. He lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove/Atlantic Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?da806f12